import { useCatalogQuery } from '../core/queries/catalog';

export function useCatalog(type, rubric, options) {
  const query = useCatalogQuery(type, rubric, options);

  return {
    items: query.data?.items || [],
    loading: query.isLoading,
    error: query.error ?? null,
    isError: query.isError,
    refetch: query.refetch,
  };
}

export default useCatalog;
